import { FC, Fragment, useMemo, useState } from "react";
import { CMSStaticSection } from "../../../models";
import React from "react";
import { JCMSStaticModal } from "../JCMSStaticModal/JCMSStaticModal";
import { JCMSCard } from "../../../JCMSCard/JCMSCard";

export interface JCMSStaticCardProps extends CMSStaticSection.Card {
    onClick?: () => void
}

export const JCMSStaticCard: FC<JCMSStaticCardProps> = props => {
    if (props.enabled === false) return <></>

    const [open, setOpen] = useState<boolean>(false)

    const modalSection = useMemo(() => {
        if (props.sections?.length) {
            for (const section of props.sections) {
                if (CMSStaticSection.isModal(section)) {
                    return section
                }
            }
        }
        return;
    }, [props.sections])

    function onClick() {
        if (props.onClick) {
            props.onClick()
        } else if (modalSection) {
            setOpen(true)
        }
    }



    return (
        <Fragment>
            <JCMSCard {...props} {...(props.options || {})} onClick={onClick} />
            {
                modalSection && (
                    <JCMSStaticModal {...modalSection} open={open} onCancel={() => setOpen(false)} />
                )
            }
        </Fragment>
    )
}

